<template>
  <div>
    <img src="../assets/dongurifm-logo.jpg" alt class="header-img" />

    <div class="container">
      <ais-instant-search :search-client="searchClient" index-name="dongurifm">
        <label for="search" class="search-label">
          <span class="field-label">過去のエピソードを検索</span>
        </label>
        <ais-search-box placeholder="コンビニ" class="searchbox" type="search" />
        <div class="search-panel">
          <div class="search-panel__results">
            <ais-hits>
              <template slot="item" slot-scope="{ item }">
                <router-link :to="{ name: 'episode', params: { id: item.id } }" class="item-link">
                  <p>
                    <ais-highlight :hit="item" attribute="title" class="item-title" />
                  </p>
                  <p class="item-date">{{ item.display_date | dateFilter }}</p>
                  <p>
                    <ais-highlight :hit="item" attribute="description" class="item-description" />
                  </p>
                </router-link>
              </template>
            </ais-hits>
            <div class="pagination">
              <ais-pagination />
            </div>
          </div>
        </div>
      </ais-instant-search>
    </div>
  </div>
</template>

<script>
import algoliasearch from "algoliasearch/lite";
import "instantsearch.css/themes/algolia-min.css";

export default {
  data() {
    return {
      searchClient: algoliasearch(
        "8X3KKUCFP5",
        "1e36e5d9098d16bee2a40981cc981e91"
      )
    };
  },
  filters: {
    dateFilter: function(time) {
      return time.slice(0, 10);
    }
  }
};
</script>

<style>
body,
h1 {
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

.header {
  display: flex;
  align-items: center;
  min-height: 50px;
  padding: 0.5rem 1rem;
  color: #fff;
  margin-bottom: 1rem;
}

.header-img {
  text-align: center;
  width: 25%;
}

.container {
  margin: 0 auto;
  padding: 1rem;
}

.search-panel__filters {
  flex: 1;
  margin-right: 1em;
}

.search-panel__results {
  flex: 3;
}

.searchbox {
  margin-bottom: 3rem;
  padding: 0.5rem 1.7rem;
}

.ais-SearchBox-input {
  border-radius: 35px;
  height: 2.8rem;
  outline: none;
}

.pagination {
  margin: 2rem auto;
  text-align: center;
}

.item-link {
  width: 100%;
  position: relative;
  display: inline-block;
  text-decoration: none;
}

.item-title {
  padding: 30px;
  text-align: left;
  color: #bda296;
  word-break: break-all;
  font-weight: bolder;
  font-size: 1.2rem;
}

.item-title .ais-Highlight-highlighted {
  font-size: 1.2rem;
}

.item-date {
  color: #bda296;
}

.item-description {
  padding: 30px;
  text-align: left;
  color: #bda296;
  word-break: break-all;
}

.search-label {
  color: #bda296;
}

.ais-Hits-list {
  list-style-type: none;
}

.ais-Hits-item {
  width: calc(100% - 1rem);
  height: calc(10% - 1rem);
  padding: 10px;
}
</style>
